import React, { useEffect, useState } from "react";
import './Marquee.css'
import Marquee from "react-fast-marquee";
const MarqueeComponent = () => {
    const currentDate = new Date();
    const locale = 'ar';
    const options = { month: 'long' };
    const formatter = new Intl.DateTimeFormat(locale, options);
    const arabicMonth = formatter.format(currentDate);
    const currentDay = new Date ().getDate()
    const [show, setShow] = useState(false)
    useEffect(() => {
        if (currentDay){
            if ((currentDay >= 15) && (currentDay <=20)){
                setShow(true)
            }
        }
    },[currentDay])
    return (
        <>
        {show && <div className="marquee_wrapper">
            <Marquee direction="rigth" speed={70}>
                {`رجاء  تحديث  موقف  تنفيذ  الإجراءات  الخاصة  بجهاتكم  الموقرة  خلال  الفترة  من  يوم  15 ليوم  20  من  شهر ${arabicMonth}`}
            </Marquee>
        </div>}
        </>
    )
}
export default MarqueeComponent